import { render, staticRenderFns } from "./LeadCommunicationHistory.vue?vue&type=template&id=c6cb1a58&scoped=true&"
import script from "./LeadCommunicationHistory.vue?vue&type=script&lang=js&"
export * from "./LeadCommunicationHistory.vue?vue&type=script&lang=js&"
import style0 from "./LeadCommunicationHistory.vue?vue&type=style&index=0&id=c6cb1a58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cb1a58",
  null
  
)

export default component.exports